<template>
  <div>
    <!-- <label class="switch">
      <input type="checkbox" @click="popupActive=true" :checked="value == '1'" />
      <span class="slider round"></span>
    </label>-->

    <b-form-checkbox
      @click.native="popupActive = true"
      value="1"
      unchecked-value="2"
      v-model="form.contract_active"
      switch
      class="table-status-icon"
    ></b-form-checkbox>

    <div class="demo-alignment">
      <vs-popup
        :id="'popmodalS' + params.data.user_id"
        :button-close-hidden="true"
        class="holamundo p-2"
        title="User Status"
        :active.sync="popupActive"
      >
        <div class="text-center">
          <h5>Do you want to change Status ?</h5>
          <div class="vx-row mt-5">
            <div class="vx-col mx-auto">
              <!-- :disabled="submitStatus" -->
              <vs-button
                color="success"
                type="filled"
                @click="onChangeCheckbox()"
                class="mr-3"
                >Yes</vs-button
              >
              <vs-button color="danger" type="filled" @click="privStatus()"
                >No</vs-button
              >
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
  <!--  -->
</template>

<script>
import Vue from "vue";
import userService from "@/services/UserService.js";

export default Vue.extend({
  data() {
    return {
      params: null,
      popupActive: false,
      form: {
        contract_active: "1",
      },
      copy_contract_active: null,
    };
  },
  beforeMount() {
    this.form = this.params.data;
    this.copy_contract_active = this.form.contract_active;
  },
  beforeDestroy() {
    let _id = document.getElementById("popmodalS" + this.params.data.user_id);
    //console.log("_id", _id);
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    onChangeCheckbox: function () {
      console.log(123);
      this.$vs.loading();
      // this.value = this.value === "1" ? "2" : "1";
      let id = this.params.data.user_id;

      let payload = {
        user_mobile: this.form.user_mobile,
        user_email: this.form.user_email,
        role_id: this.form.role_id,
        user_address: this.form.user_address,
        city_id: this.form.city_id,
        user_dob: this.form.user_dob,
        user_pic: this.form.user_pic,
        user_active: this.form.user_active,

        user_name: this.form.user_name,
        user_gender: this.form.user_gender,
        contract_level: this.form.contract_level,
        contract_active: this.form.contract_active,
      };
      // let payload = {
      //   // employment_name: this.params.data.employment_name,
      //   // company_id: this.params.data.employment_id,
      //   // description: this.params.data.description,
      //   contract_active: this.form.contract_active
      // };
      console.log("payload, id", payload, id);
      userService
        .EditUser(payload, id)
        .then((response) => {
          this.$vs.loading.close();
          const { data } = response;
          if (!data.error) {
            this.$vs.notify({
              title: "Updated!",
              text: data.data.message,
              iconPack: "feather",
              icon: "check_box",
              color: "success",
            });
            this.popupActive = false;
          } else {
            this.$vs.loading.close();
            console.log("data :", data);
            this.$vs.notify({
              title: "Error!",
              text: data.error.message,
              iconPack: "feather",
              icon: "check_box",
              color: "warning",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    privStatus: function () {
      this.popupActive = false;
      this.form.contract_active = this.copy_contract_active;
    },
  },
});
</script>
